<template>
    <div class="CompanyManagement" v-loading.fullscreen.lock="fullscreenLoading" :style="{ height: Height - 105 + 'px'}">
        <el-container :style="{ height: Height - 105 + 'px'}">
            <el-header height="80px">
                <el-row>
                    <el-col>
                        <h2>公司管理</h2>
                    </el-col>
                    <el-col :span="12" style="text-align: left; padding-left: 10px;">
                        <el-popover
                            placement="bottom-start"
                            width="400"
                            trigger="manual"
                            v-model="visible">
                            <el-form ref="ruleForms" :model="queryform" label-width="100px">
                                <el-form-item label="公司名称">
                                    <el-input v-model="queryform.keyword"></el-input>
                                </el-form-item>
                                <el-form-item label="房间号">
                                    <el-input v-model="queryform.room"></el-input>
                                </el-form-item>
                            </el-form>
                            <el-row>
                                <el-col style="text-align: right;">
                                    <el-button type="primary" @click="Reset">重置</el-button>
                                    <el-button type="primary" @click="ConfirmQuery">确认</el-button>
                                </el-col>
                            </el-row>
                            <el-button type="primary" slot="reference" @click="visible = !visible">查询</el-button>
                        </el-popover>
                    </el-col>
                    <el-col :span="12">
                        <el-button type="primary" @click="AddCompany">新增</el-button>
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-table :height="Height - 265" :data="tableData" border style="width: 100%">
                    <el-table-column prop="img" label="Logo">
                        <template slot-scope="scope">
                            <!-- {{scope.$index}} -->
                            <el-popover
                                placement="bottom-start"
                                trigger="hover">
                                <img v-if="JSON.parse(scope.row.img).length !== 0" :src="url + JSON.parse(scope.row.img)[0].response" height="150px">
                                <img v-if="JSON.parse(scope.row.img).length !== 0" slot="reference" :src="url + JSON.parse(scope.row.img)[0].response" height="25px">
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column prop="title" label="公司名称" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="contact" label="第一联系人">
                    </el-table-column>
                    <el-table-column prop="tel" label="第一联系人电话">
                    </el-table-column>
                    <el-table-column prop="contact1" label="第二联系人">
                    </el-table-column>
                    <el-table-column prop="tel1" label="第二联系人电话">
                    </el-table-column>
                    <el-table-column prop="type" label="公司类别">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type == 0">Ocenter</span>
                            <span v-if="scope.row.type == 1">其它</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="intro" label="公司主营业务" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="room" label="房间号">
                    </el-table-column>
                    <el-table-column prop="address" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="EditCompany(scope.row)">编辑</el-button>
                            <el-button type="text" @click="DelCompany(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog :title="title" :visible.sync="Company" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="Company">
                    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">
                        <el-form-item label="公司名称" prop="title">
                            <el-input v-model="form.title"></el-input>
                        </el-form-item>
                        <el-form-item label="第一联系人" prop="contact">
                            <el-input v-model="form.contact"></el-input>
                        </el-form-item>
                        <el-form-item label="第一联系人电话" prop="tel">
                            <el-input v-model="form.tel"></el-input>
                        </el-form-item>
                        <el-form-item label="第二联系人">
                            <el-input v-model="form.contact1"></el-input>
                        </el-form-item>
                        <el-form-item label="第二联系人电话" prop="tel1">
                            <el-input v-model="form.tel1"></el-input>
                        </el-form-item>
                        <el-form-item label="房间号">
                            <el-input v-model="form.room"></el-input>
                        </el-form-item>
                        <el-form-item label="公司类别">
                            <el-select v-model="form.type" placeholder="请选择">
                                <el-option label="Ocenter" :value="0">
                                </el-option>
                                <el-option label="其它" :value="1">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="公司状态">
                            <el-select v-model="form.status" placeholder="请选择">
                                <el-option label="停用" :value="0">
                                </el-option>
                                <el-option label="正常" :value="1">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="公司主营业务" style="display: block; width: 100%;">
                            <el-input type="textarea" v-model="form.intro"></el-input>
                        </el-form-item>
                        <el-form-item label="备注" style="display: block; width: 100%;">
                            <el-input type="textarea" v-model="form.remark"></el-input>
                        </el-form-item>
                        <el-form-item label="公司logo" style="display: block; width: 100%;">
                           <!-- <el-input v-model="formData.imgs" placeholder="请输入容纳人数"></el-input> -->
                           <el-upload
                                class="upload-demo"
                                :action="http + '/Spaceorder/upload_file'"
                                :data="Uploaddata"
                                :on-remove="handleRemove"
                                :before-remove="beforeRemove"
                                :on-success="SiteUploadSuccess"
                                :before-upload="SiteBeforeUpload"
                                multiple
                                :limit="1"
                                :on-exceed="handleExceed"
                                :file-list="fileList">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="Company = false">取 消</el-button>
                        <el-button type="primary" @click="SaveCompany" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog>
            </el-main>
            <el-footer>
                <el-row>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="total"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12" style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="->, sizes"
                            :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
  </div>
</template>

<script>
/*eslint-disable */
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
export default {
    name: "CompanyManagement",
    data () {
        return {
            url: https.http,
            visible: false,
            fullscreenLoading: false,
            tableData: [],
            Company: false,
            form: {
                title: '',
                contact: '',
                tel: '',
                contact1: '',
                tel1: '',
                remark: '',
                img: [],
                intro: '',
                room: '',
                status: 1,
                type: 0
            },
            title: '',
            currentPage: 1,
            Size: 20,
            total: 1,
            visible: false,
            queryform: {
                keyword: '',
                room: ''
            },
            Uploaddata: {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            },
            http: https.https,
            preview: false,
            fileList: [],
            rules: {
                title: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                tel: [
                    { required: true, message: '请输入电话', trigger: 'blur' },
                    { pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                ],
                tel1: [
                    { pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                ],
                contact: [
                    { required: true, message: '请输入第一联系人', trigger: 'blur' },
                ]
            },
            confirmloding: false
        }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        AddCompany () {
            this.Company = true
            this.title = '新增公司'
            this.form = {
                title: '',
                contact: '',
                tel: '',
                contact1: '',
                tel1: '',
                remark: '',
                img: [],
                intro: '',
                room: '',
                status: 1,
                type: 0
            }
            this.fileList = []
        },
        handleSizeChange(size) {
            this.Size = size
            this.fullscreenLoading = true
            this.GetCompanyList(this.queryform.keyword, this.queryform.room)
        },
        handleCurrentChange(page) {
            this.currentPage = page
            this.fullscreenLoading = true
            this.GetCompanyList(this.queryform.keyword, this.queryform.room)
        },
        GetCompanyList (keyword, room) {
            let data = {
                keyword: keyword,
                room: room,
                limit: this.Size,
                page: this.currentPage,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$store.dispatch('CompanyListShow', data).then(res => {
                this.fullscreenLoading = false
                this.total = res.something
                this.tableData = res.data
                this.form = {
                    title: '',
                    contact: '',
                    tel: '',
                    contact1: '',
                    tel1: '',
                    remark: '',
                    img: [],
                    intro: '',
                    room: '',
                    status: 1,
                    type: 0
                }
                this.visible = false
            })
        },
        Reset () {
           this.$refs['ruleForms'].resetFields();
           this.queryform = {
                keyword: '',
                room: ''
            }
        },
        ConfirmQuery() {
            this.currentPage = 1
            this.GetCompanyList(this.queryform.keyword, this.queryform.room)
        },
        handleRemove(file, fileList) {
             this.form.img = fileList
            //  console.log(fileList)
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        SiteBeforeUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJPG) {
                this.$message.error('只能上传jpeg或png图片！');
            }
            return isJPG;
        },
        SiteUploadSuccess(response, file, fileList) {
            this.form.img = fileList
        },
        SaveCompany() {
            let that = this
            let data = JSON.parse(JSON.stringify(this.form))
            data.ADMIN_ID = getAdminId();
            data.ADMIN_TOKEN = getToken();
            data.img = JSON.stringify(this.form.img)
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.confirmloding = true
                    that.$store.dispatch('SaveCompany', data).then(res => {
                        if (res.flag) {
                            that.$message({
                                message: res.message,
                                type: 'success'
                            })
                            that.confirmloding = false
                            that.Company = false
                            that.fullscreenLoading = true
                            that.GetCompanyList(that.queryform.keyword, that.queryform.room)
                        } else {
                            that.$message({
                                message: res.message,
                                type: 'warning'
                            })
                        }
                    })
                } else {
                    // that.$message({
                    //     message: '请先填写必填项',
                    //     type: 'error'
                    // })
                    return false;
                }
            });
            
        },
        EditCompany(row) {
            this.Company = true
            this.title = '编辑公司'
            this.form = JSON.parse(JSON.stringify(row))
            this.fileList = JSON.parse(this.form.img)
            this.form.img = JSON.parse(this.form.img)
        },
        DelCompany(row) {
            this.$confirm('是否删除该公司？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.ADMIN_ID = getAdminId();
                row.ADMIN_TOKEN = getToken();
                this.$store.dispatch('DelCompany', row).then(res => {
                     if (res.flag) {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        })
                        this.fullscreenLoading = true
                        this.GetCompanyList(this.queryform.keyword, this.queryform.room)
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        })
                    }
                })
            }).catch(() => {
            })
        }
    },
    created() {
        this.fullscreenLoading = true
        this.GetCompanyList(this.queryform.keyword, this.queryform.room)
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    }
}
</script>

<style>
.CompanyManagement {
    width: 100%;
}
.CompanyManagement .el-header .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.CompanyManagement .el-header .el-row .el-col h2 {
    text-align: center;
}
.CompanyManagement .el-header .el-row .el-col {
    text-align: center;
}
.CompanyManagement .el-header .el-row .el-col:last-child {
    text-align: right;
}
.CompanyManagement .el-main {
    padding-top: 0px;
    padding-bottom: 0px;
}
.CompanyManagement .el-main .Company .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 0px;
}
.CompanyManagement .el-main .Company .el-dialog__body .el-form-item:first-child {
    display: block;
    width: 100%;
}
.CompanyManagement .el-main .Company .el-dialog__body .el-form-item {
    display: inline-block;
    width: 50%;
}
</style>
